import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api/client";
import { RungBadge } from "../components/Rung";
import { ChainGraph } from "../components/ChainGraph";
import { shortDid } from "../util";
import { DidLabel } from "../components/DidLabel";

/** /d/{did}: a holder's public chain. Rungs and badges; never a number. */
export function HolderPage() {
  const { did = "" } = useParams();
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    // A DID with no claims has no chain yet (404): the page still shows the DID.
    api.GET("/dids/{did}/chain", { params: { path: { did } } }).then((r) => (r.data ? setData(r.data) : setErr("No claims yet.")));
  }, [did]);
  const header = (<>
    <h1>Chain</h1>
    <p data-testid="holder-did"><DidLabel did={did} /></p>
    <p className="hint mono">{shortDid(did)}</p>
  </>);
  if (err) return <div>{header}<p className="note">{err}</p></div>;
  if (!data) return <div>{header}<p className="note">Loading…</p></div>;
  return (
    <div>
      {header}
      {data.graph && <ChainGraph centre={did} nodes={data.graph.nodes} edges={data.graph.edges} />}
      <h2>Claims</h2>
      {data.claims.length === 0 ? <p className="note">No claims yet.</p> : data.claims.map((c: any) => (
        <div className="card" key={c.claim_id} style={{ marginBottom: 10 }} data-testid="holder-claim">
          <div className="row" style={{ justifyContent: "space-between" }}>
            <Link to={`/c/${c.claim_id}`}><b>{c.claim.description}</b></Link><RungBadge rung={c.rung} />
          </div>
          <div className="hint">{c.claim.claim_type.replace(/_/g, " ")} · {c.vouches.filter((v: any) => v.decision === "signed").length} vouches{c.anchors.some((a: any) => a.status === "active") ? " · anchored" : ""}</div>
        </div>))}
    </div>
  );
}
